import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';
import supplierService from '../../../services/supplierService';

const PopularBeansChart = ({ language, supplierId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const content = {
    en: {
      title: 'Most Popular Coffee Beans',
      revenue: 'Revenue (USD)',
      orders: 'Orders',
      noData: 'No sales data available'
    },
    zh: {
      title: '最受欢迎的咖啡豆',
      revenue: '收入（美元）',
      orders: '订单',
      noData: '没有销售数据'
    }
  };

  const t = content?.[language];

  useEffect(() => {
    loadPopularBeans();
  }, [supplierId]);

  const loadPopularBeans = async () => {
    try {
      setLoading(true);
      const beans = await supplierService?.getPopularBeans(supplierId);
      
      const chartData = beans?.slice(0, 5)?.map(item => ({
        name: language === 'en' ? item?.bean?.nameEn : item?.bean?.nameZh,
        revenue: Number(item?.totalRevenue)?.toFixed(0),
        orders: item?.totalOrders
      }));
      
      setData(chartData);
    } catch (error) {
      console.error('Failed to load popular beans:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-center h-64">
          <Icon name="Loader2" size={32} className="animate-spin text-primary" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Coffee" size={20} className="text-primary" />
        <h3 className="text-lg font-heading font-semibold text-foreground">{t?.title}</h3>
      </div>

      {data?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Coffee" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">{t?.noData}</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="name" 
              stroke="var(--color-muted-foreground)"
              angle={-45}
              textAnchor="end"
              height={100}
            />
            <YAxis stroke="var(--color-muted-foreground)" />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Bar dataKey="revenue" fill="var(--color-primary)" name={t?.revenue} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default PopularBeansChart;